import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button.tsx";
import { Navbar } from "@/components/layout/Navbar.tsx";
import { Footer } from "@/components/layout/Footer.tsx";

export function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />

      <main className="flex-1 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-9xl font-bold font-pixel text-primary">404</h1>
          <p className="text-2xl text-muted-foreground mt-4 mb-8">
            {t("notFound.message", { defaultValue: "Page not found" })}
          </p>
          <Link to="/">
            <Button variant="outline">
              {t("notFound.goHome", { defaultValue: "Go back home" })}
            </Button>
          </Link>
        </div>
      </main>

      <Footer />
    </div>
  );
}
